import { OrbitalInsightSatelliteType, OrbitStartOptionsType } from "./orbital-insights-type";

export const getAllOrbitNames = (data: OrbitalInsightSatelliteType | null, orbitStartOption: OrbitStartOptionsType) => {
    if (!data) return []
    const orbits: string[] = ['All Orbits']
    const option = orbitStartOption === 'Sunlit' ? 'orbitsEndingWithEclipse' : 'orbitsByOrbitalPeriod'
    data?.[option]?.forEach((orbit) => {
        const name = `Orbit ${orbit.orbitNumber}`
        if (!orbits.includes(name)) {
            orbits.push(name)
        }
    })
    return orbits
}

export const getOrbitalInsightDetails = (data: OrbitalInsightSatelliteType | null, orbitStartOption: OrbitStartOptionsType) => {
    if (!data) return []
    const option = orbitStartOption === 'Sunlit' ? 'orbitsEndingWithEclipse' : 'orbitsByOrbitalPeriod'
    return data?.[option] || []
}